export interface FavoritePreferenceRepository {
  load(key: string): readonly string[] | null;
  save(key: string, featureIds: readonly string[]): void;
}

export class BrowserFavoritePreferenceRepository implements FavoritePreferenceRepository {
  load(key: string) {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return null;
      const value = JSON.parse(raw);
      return Array.isArray(value)
        ? value.filter((item): item is string => typeof item === 'string')
        : null;
    } catch {
      return null;
    }
  }

  save(key: string, featureIds: readonly string[]) {
    localStorage.setItem(key, JSON.stringify(featureIds));
  }
}

export function projectFavoriteIds(
  saved: readonly string[] | null,
  allowed: readonly string[],
  fallback: readonly string[],
) {
  const allowedIds = new Set(allowed);
  if (saved === null) return fallback.filter((id) => allowedIds.has(id));
  const migrated = saved.map((id) => (id === 'work-plan' ? 'work-permit' : id));
  return [...new Set(migrated)].filter((id) => allowedIds.has(id));
}

export function moveFavorite(ids: readonly string[], id: string, offset: -1 | 1) {
  const from = ids.indexOf(id);
  const to = from + offset;
  if (from < 0 || to < 0 || to >= ids.length) return [...ids];
  const next = [...ids];
  [next[from], next[to]] = [next[to]!, next[from]!];
  return next;
}
